import customAxiosInterceptor from "../customAxiosInterceptor";

// Fetch recent articles (optionally filtered by category slug)
// /article
export const fetchRecentArticlesThunk = async (
  slug: string | null | undefined,
  thunkAPI: any
) => {
  try {
    const response = slug
      ? await customAxiosInterceptor.get("/article", {
          params: { ac_slug: slug },
        })
      : await customAxiosInterceptor.get("/article");
    return response.data.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.msg || error.message);
  }
};

// Fetch paginated & filtered articles
// /article/page
export const fetchFilteredArticlesThunk = async (
  params: {
    ac_slug: string;
    page: number;
    take: number;
    order?: string;
    min_price?: number;
    max_price?: number;
    article_filters?: string;
  },
  thunkAPI: any
) => {
  try {
    const response = await customAxiosInterceptor.get("/article/page", {
      params,
    });
    return response.data; // expects { data: Article[], meta: {...} }
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.msg || error.message);
  }
};

// Fetch available filter definitions for a category
// /article/filters
export const fetchFiltersListThunk = async (
  params: {
    ac_slug: string;
    url_filters?: { filter_label: string; filter_values: string }[];
  },
  thunkAPI: any
) => {
  try {
    const response = await customAxiosInterceptor.get("/article/filters", {
      params: {
        ac_slug: params.ac_slug,
        // prosleđujemo aktivne URL filtere kao JSON string
        ...(params.url_filters?.length
          ? { url_filters: JSON.stringify(params.url_filters) }
          : {}),
      },
    });
    return {
      data: response.data.data, // array of filter definitions
      url_filters: params.url_filters || [], // passes through which filters are active
    };
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.msg || error.message);
  }
};

// Fetch discounted articles
// /article/sale
export const fetchDiscountedArticlesThunk = async (
  params: {
    page: number;
    take: number;
    order?: string;
    min_price?: number;
    max_price?: number;
  },
  thunkAPI: any
) => {
  try {
    const response = await customAxiosInterceptor.get("/article/sale", {
      params,
    });
    return response.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.msg || error.message);
  }
};
